// extracted by mini-css-extract-plugin
export default {"root":"roles_root__M6WsX","rootIcon":"roles_rootIcon__HYNx5"};